module.exports = "<h1>Various examples</h1>\r\n\r\n<router-outlet></router-outlet>"